import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Link from '../Link/Link';
import s from './ListPlaceStep1.css';
import logoPrimary from '/public/eslipin-logo-secundario-blue.png';
import correctIcon from '/public/SiteIcons/correct.svg';

// Step & screen configuration
const STEP_CONFIG = {
  // Step 1: Información del alojamiento (5 screens)
  room: { step: 1, current: 1, total: 5, title: 'Información del alojamiento' },
  'room-type': { step: 1, current: 2, total: 5, title: 'Información del alojamiento' },
  bedrooms: { step: 1, current: 3, total: 5, title: 'Información del alojamiento' },
  location: { step: 1, current: 4, total: 5, title: 'Información del alojamiento' },
  map: { step: 1, current: 5, total: 5, title: 'Información del alojamiento' },

  // Step 2: Fotos y comodidades (3 screens)
  amenities: { step: 2, current: 1, total: 3, title: 'Fotos y comodidades' },
  photos: { step: 2, current: 2, total: 3, title: 'Fotos y comodidades' },
  'review-photos': { step: 2, current: 3, total: 3, title: 'Fotos y comodidades' },

  // Step 3: Información del alojamiento (8 screens)
  title: { step: 3, current: 1, total: 8, title: 'Información del alojamiento' },
  description: { step: 3, current: 2, total: 8, title: 'Información del alojamiento' },
  'min-max-nights': { step: 3, current: 3, total: 8, title: 'Información del alojamiento' },
  pricing: { step: 3, current: 4, total: 8, title: 'Información del alojamiento' },
  discount: { step: 3, current: 5, total: 8, title: 'Información del alojamiento' },
  'advance-notice': { step: 3, current: 6, total: 8, title: 'Información del alojamiento' },
  calendar: { step: 3, current: 7, total: 8, title: 'Información del alojamiento' },
  'booking-scenarios': { step: 3, current: 8, total: 8, title: 'Información del alojamiento' },
};

const STEP_DEFAULTS = {
  1: { total: 5, title: 'Información del alojamiento' },
  2: { total: 3, title: 'Fotos y comodidades' },
  3: { total: 8, title: 'Información del alojamiento' },
};

class ListStepHeader extends Component {
  static propTypes = {
    formPage: PropTypes.string,
    step: PropTypes.number,
  };

  render() {
    const { formPage, step } = this.props;

    let meta = STEP_CONFIG[formPage];
    if (!meta) {
      const stepNum = step || 1;
      const defaults = STEP_DEFAULTS[stepNum] || STEP_DEFAULTS[1];
      meta = {
        step: stepNum,
        current: 1,
        total: defaults.total,
        title: defaults.title,
      };
    }

    const { title, current, total } = meta;

    return (
      <header className={s.stepHeader}>
        <div className={s.stepHeaderLeft}>
          <Link to={'/'} className={s.stepHeaderLogoLink}>
            <img src={logoPrimary} className={s.stepHeaderLogo} alt="eslipin" />
          </Link>
        </div>
        <div className={s.stepHeaderRight}>
          <span className={s.stepHeaderTitle}>{title}</span>
          <span className={s.stepHeaderDivider}>·</span>
          <span className={s.stepHeaderCount}>
            {current} de {total}
          </span>
          <div className={s.stepDotsContainer}>
            {Array.from({ length: total }).map((_, index) => {
              const stepNumber = index + 1;
              const isCompleted = stepNumber < current;
              const isVisited = stepNumber <= current;
              return (
                <React.Fragment key={stepNumber}>
                  {index > 0 && (
                    <span
                      className={cx(s.stepDotConnector, {
                        [s.stepDotConnectorActive]: isVisited,
                      })}
                    />
                  )}
                  <span
                    className={cx(s.stepDot, {
                      [s.stepDotActive]: isVisited,
                      [s.stepDotCompleted]: isCompleted,
                    })}
                  >
                    {isCompleted && (
                      <img src={correctIcon} className={s.stepDotIcon} alt="" />
                    )}
                  </span>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </header>
    );
  }
}

export default withStyles(s)(ListStepHeader);
